export default __webpack_public_path__ + "static/media/Video3.de40f4cb.mp4";